import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ButtonLink } from './ButtonLink';
import { SectionLabel } from './SectionLabel';
const socialLinks = [{
  label: 'LinkedIn',
  href: 'https://www.linkedin.com/in/alex-kusminov/'
}, {
  label: 'Dribbble',
  href: 'https://dribbble.com/'
}, {
  label: 'Twitter',
  href: 'https://twitter.com/'
}];
export function Footer() {
  const reduceMotion = useReducedMotion();
  return <footer id="contact" className="relative isolate overflow-hidden pb-10 pt-24 md:pb-12 md:pt-32" data-id="element-301" data-mp="3ufjz8918i2yv">
      <div aria-hidden="true" className="hero-dot-grid absolute inset-0 z-0 opacity-35" data-id="element-302" data-mp="37xx4ku5y8k4" />
      <div className="site-container relative z-10" data-id="element-303" data-mp="3ldu4ouc22nwv">
        <div className="border-t border-foreground pt-5" data-id="element-304" data-mp="3qd6tvlqeg72m">
        <SectionLabel data-id="element-305" data-mp="3qbly5sscmi36">Contact</SectionLabel>
      </div>
      <div className="grid gap-12 py-16 md:grid-cols-12 md:items-end md:py-24" data-id="element-306" data-mp="29yxdpewb9omv">
        <motion.div initial={reduceMotion ? false : {
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.28,
          ease: [0.22, 1, 0.36, 1]
        }} className="md:col-span-8" data-id="element-307" data-mp="2ey0a6ay86mj8">
          <h2 className="max-w-4xl text-balance text-5xl font-medium leading-[1.02] tracking-[-0.04em] md:text-7xl" data-id="element-308" data-mp="3v7gfq1b2ac9t">
            Let’s build something remarkable together.
          </h2>
          <ButtonLink href="mailto:info@kusminov.com" className="mt-10" data-id="element-309" data-mp="830jhjn6y710">
            info@kusminov.com
          </ButtonLink>
        </motion.div>
        <nav className="flex flex-wrap gap-x-7 gap-y-3 md:col-span-4 md:justify-end" aria-label="Social links" data-id="element-310" data-mp="32vybgbc8o4g">
          {socialLinks.map(link => <a key={link.label} href={link.href} target="_blank" rel="noreferrer" className="font-display text-base font-medium uppercase tracking-[0.1em] text-muted transition-colors duration-200 hover:text-cobalt focus-visible:outline-none focus-visible:text-cobalt" data-id="element-311" data-mp="ctqo2unsm5un">
              {link.label}
            </a>)}
        </nav>
      </div>
      <div className="flex flex-col gap-3 border-t border-border pt-5 font-display text-sm font-medium uppercase tracking-[0.08em] text-muted md:flex-row md:items-center md:justify-between" data-id="element-312" data-mp="ytek6ham6csq">
        <p data-id="element-313" data-mp="18kiswz9p51f4">© {new Date().getFullYear()} Alexander Kusminov</p>
        <p data-id="element-314" data-mp="18lu0la69itbi">St. Petersburg, Florida</p>
      </div>
      </div>
    </footer>;
}